import React from "react";
import { Switch } from "@material-ui/core";
import { Form, Col, Row } from "react-bootstrap";

export function MailAccountForm({
  handleChange,
  values
 }) {
  const mailPortNumber = values.mailPortNumber != null ? values.mailPortNumber : "";

  return (
    <>
      <Form.Group as={Row} controlId="mailAddress">
        <Form.Label column sm={4}>
          Mail Adresi
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="text" value={values.mailAddress} placeholder="Mail Adresi" onChange={handleChange} />
        </Col>
      </Form.Group>
                    
      <Form.Group as={Row} controlId="mailPassword">
        <Form.Label column sm={4}>
          Şifre
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="text" value={values.mailPassword} placeholder="Şifre" onChange={handleChange} />
        </Col>
      </Form.Group>
                    
      <Form.Group as={Row} controlId="mailServerAddress">
        <Form.Label column sm={4}>
          SMTP Sunucu Adresi
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="text" value={values.mailServerAddress} placeholder="SMTP Sunucu Adresi" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="mailPortNumber">
        <Form.Label column sm={4}>
          Port Numarası
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="number" min={1} value={mailPortNumber} placeholder="Port Numarası" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="mailSSLUsage">
        <Form.Label column sm={4}>
          SSL Kullanımı
        </Form.Label>
        <Col sm={8}>
          <Switch checked={values.mailSSLUsage} onChange={handleChange("mailSSLUsage")} />
        </Col>
      </Form.Group>
    </>        
  );
}